import React from 'react';

import {SignoffRequestModal} from 'app/components/general/GenericDocumentActionButtons/SignoffRequestModal';
import {
  DocSidebarPagePanels,
  StyledFooterDIV,
} from 'app/general/structures/DocSidebarPagePanels';
import {DocumentSignoffInfiniteListFetcher} from 'app/signoffs/datafetchers';
import {gt} from 'app/utils/i18n';

import {SignoffDocumentHistory} from './SignoffDocumentHistory';
import {SignoffDocumentStats} from './SignoffDocumentStats';

import type {BaseActionableDocumentType} from 'app/general/types';
import type {DocumentSerializedType} from 'sweet-types';

type Props = {
  document: Exclude<BaseActionableDocumentType, DocumentSerializedType>;
  refreshFunc: () => Promise<unknown>;
  onClose: () => void;
};

export const DetailPageSignoffSidebar = ({
  document,
  refreshFunc,
  onClose,
}: Props): JSX.Element => {
  const [isModalVisible, setModalVisible] = React.useState(false);
  return (
    <DocSidebarPagePanels
      title={gt('Sign Off Log')}
      onClose={onClose}
      footer={
        <StyledFooterDIV>
          <button
            className="btn btn-secondary btn-sm btn-block"
            onClick={() => setModalVisible(true)}
          >
            <i className="fa fa-signature" /> {gt('Request Sign Off')}
          </button>
        </StyledFooterDIV>
      }
    >
      <DocumentSignoffInfiniteListFetcher
        fetchParams={{
          object_id: document.id,
          content_type: document.content_type,
          page_size: 1000,
        }}
      >
        {({allResults, loading, totalCount, refetchData}) => {
          return loading ? null : (
            <>
              <SignoffDocumentStats
                document={document}
                signoffsList={allResults}
                loading={loading}
              />
              {totalCount > 0 ? (
                <SignoffDocumentHistory document={document} />
              ) : null}
              <SignoffRequestModal
                document={document}
                isOpen={isModalVisible}
                contentType={document.content_type}
                onClose={() => setModalVisible(false)}
                onSuccess={() => Promise.all([refetchData(), refreshFunc()])}
              />
            </>
          );
        }}
      </DocumentSignoffInfiniteListFetcher>
    </DocSidebarPagePanels>
  );
};
